import "bootstrap-icons/font/bootstrap-icons.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.css';


import HomeView from './views/application/HomeView';
import NotFoundView from "./views/application/NotFoundView";
import ApplicationAboutView from "./views/applicationAbout/ApplicationAboutView";
import ApplicationContactView from "./views/applicationContact/ApplicationContactView";


import UserBudgetView from './views/userBudget/UserBudgetView';
import UserRegisterView from './views/userCreate/UserRegisterView';
import UserExpensesView from './views/userExpenses/UserExpensesView';
import UserLoginView from './views/userLogin/UserLoginView';
import UserMainView from './views/userMain/UserMainView';
import UserPaymentsView from "./views/userPayments/UserPaymentsView";
import UserProfileView from "./views/userProfile/UserProfileView";
import UserRecoverView from './views/userRecover/UserRecoverView';
import UserUnauthorizedView from './views/userUnauthorized/UserUnauthorizedView';
import UserCreditsView from "./views/userCredits/UserCreditsView";
import UserPaymentsCreateView from "./views/userPayments/UserPaymentsCreateView";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomeView />}></Route>
                <Route path='notfound' element={<NotFoundView />} ></Route>


                <Route path="about" element={<ApplicationAboutView />}></Route>
                <Route path="contact" element={<ApplicationContactView />}></Route>


                <Route path="user" element={<UserMainView />}></Route>
                <Route path="user/budget" element={<UserBudgetView />}></Route>
                <Route path="user/credits" element={<UserCreditsView />}></Route>
                <Route path="user/expenses" element={<UserExpensesView />}></Route>
                <Route path="user/login" element={<UserLoginView />}></Route>
                <Route path="user/payments" element={<UserPaymentsView />}></Route>
                <Route path="user/payments/create" element={<UserPaymentsCreateView title="Crear método de pago" />}></Route>
                <Route path="user/payments/edit/:id" element={<UserPaymentsCreateView title="Modificar método de pago" />}></Route>
                <Route path="user/profile" element={<UserProfileView />}></Route>
                <Route path="user/recover" element={<UserRecoverView />}></Route>
                <Route path="user/register" element={<UserRegisterView />}></Route>
                <Route path="user/unauthorized" element={<UserUnauthorizedView />}></Route>


                <Route path='*' element={<NotFoundView />} />
            </Routes>
        </BrowserRouter>
    );
}


export default App;